export const SET_MOBILE_DEVICE = 'SET_MOBILE_DEVICE';
export const setMobileDevice = (isMobile) => {
    return {
        type: SET_MOBILE_DEVICE,
        payload: isMobile
    }
}